import { DeepReadonly } from 'ts-essentials';

export default function canStartInPersonSession({
  currentUserContact,
  currentSigningOrder,
  hosts,
  signers,
  signings,
}: {
  currentUserContact: string | null;
  currentSigningOrder: number;
  hosts: DeepReadonly<{ id: string; contact: string }[]> | null;
  signers: DeepReadonly<{ id: string; order: number; hostId?: string }[]>;
  signings: Array<{ participantId: string; expiredAt: string | null }>;
}) {
  const hostMap = new Map(hosts?.map((host) => [host.id, host]) ?? []);

  const signedSignersIdSet = new Set(
    signings.filter((signing) => !signing.expiredAt).map((signing) => signing.participantId)
  );
  const currentHosts = signers
    .filter((signer) => signer.hostId)
    .filter((signer) => signer.order === currentSigningOrder)
    .filter((signer) => !signedSignersIdSet.has(signer.id))
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((signer) => hostMap.get(signer.hostId!));

  return currentHosts.some(
    (host) => host && currentUserContact && host.contact === currentUserContact
  );
}
